export const socialsFields = `
  socials {
    id: _id
    type
    link
  }
`;
